<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.CORE_PROTOCOL
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="close">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="m-35">
        <b-autocomplete
          v-model="capacitySelected.showName"
          field="name"
          :data="getCapacitiesWithParamsFiltered(filterCapacity)"
          :placeholder="General.PLACEHOLDER.SEARCH_CAPACITY_PROTOCOL"
          autocomplete
          keepFirst
          @typing="setFilterCapacity"
          @select="option => setPartData(option)"
        />
        <p class="mt-15">
          <span class="has-text-weight-semibold"
            >{{ General.CORE_PROTOCOL_ATUAL }}:</span
          >
          {{ coreProtocol }}
        </p>
      </section>

      <footer class="modal-card-foot is-align-self-flex-end">
        <div class="buttons">
          <b-button
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            @click="confirmAction"
          >
            {{ General.SAVE }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white' : 'is-orange'"
            class="is-outlined"
            @click="close"
          >
            {{ General.CANCEL }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { App, General } from "@/utils/constants";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ModalPartPermissionEdit",

  props: {
    part: {
      type: Object,
      required: true
    },
    coreProtocol: {
      type: String,
      default: ""
    },
    updateFunction: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      App,
      General,
      filterCapacity: "",
      capacitySelected: {},
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      getCapacitiesWithParamsFiltered: "getCapacitiesWithParamsFiltered",
      isContrast: "isContrast"
    })
  },

  async beforeMount() {
    this.isLoading = true;
    await this.capacityWithParamsRequest({
      part_id: this.part.id
    });
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      setPermission: "setCapacityPermissionRequest",
      capacityControlRequest: "capacityControlRequest",
      capacityWithParamsRequest: "capacityWithParamsRequest"
    }),

    setFilterCapacity(text) {
      this.filterCapacity = text;
    },

    setPartData(option) {
      this.capacitySelected = option;
    },

    async confirmAction() {
      if (!this.capacitySelected?.id) {
        return this.snackToast.open({
          message: this.App.PartAddressScreen.PLACEHOLDER.ORGAN_UNITY,
          type: "is-danger",
          duration: 8000
        });
      }
      this.isLoading = true;
      const permissions = { core_protocol: true };
      await this.setPermission({
        capacityId: [this.capacitySelected.id],
        permissions: permissions
      });
      await this.updateFunction();

      this.isLoading = false;
      this.close();
    },

    close() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  max-height: 75vh;
  background-color: $color-1;
  overflow: visible;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
